import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import withGallery from '@catalogo/service-americanas-product/src/hocs/gallery';
import ProductGalleryZoom from '@catalogo/ui-americanas-mobile-product-gallery/src/components/zoom';
import StampEvent from './components/stamp';
import { MainImage } from './components/main-image';
import { ThumbGallery } from './components/thumb-gallery';
import { Video } from './components/video';
import * as Styled from './styles';
import './app.css';

const handleClick = (setState, state) => e => {
  setState(state);
};

export const ProductGallery = ({ galleryImageProps, currentSku }) => {
  const {
    selectedImage,
    images,
    setSelectedImageIndex,
    selectedImageIndex,
    modalImages,
    name,
    hasThumbs,
  } = galleryImageProps;
  const [galleryState, setGalleryState] = useState({
    isOpen: false,
    index: selectedImageIndex,
  });

  return (
    <Styled.Container>
      {galleryState.isOpen &&
        createPortal(
          <ProductGalleryZoom
            images={modalImages}
            galleryState={galleryState}
            onClose={handleClick(setGalleryState, { isOpen: false })}
          />,
          document.getElementById('root')
        )}
      <Styled.Gallery $hasThumbs={hasThumbs}>
        <StampEvent currentSku={currentSku} />
        {selectedImage.video ? (
          <Video image={selectedImage} alt={name} />
        ) : (
          <MainImage
            selectedImage={selectedImage}
            setGalleryState={setGalleryState}
            handleClick={handleClick(setGalleryState, { isOpen: true, index: selectedImageIndex })}
            alt={name}
          />
        )}
        <ThumbGallery
          images={images}
          setSelectedImageIndex={setSelectedImageIndex}
          setGalleryState={setGalleryState}
          selectedImage={selectedImage}
          handleClick={handleClick(setGalleryState, { isOpen: true, index: selectedImageIndex })}
          alt={name}
        />
      </Styled.Gallery>
    </Styled.Container>
  );
};

export default withGallery(ProductGallery);
